export { highlightedTextStyles } from './highlightedTextStyles';
export { highlightedTextUnderlineStyles } from './highlightedTextUnderlineStyles';
